import { defineComponent, createElementBlock, openBlock, normalizeClass, unref, createElementVNode, createVNode, withCtx, renderSlot } from 'vue';
import { useBlockPositioning } from './basler-components.es382.js';
import _sfc_main$1 from './basler-components.es106.js';
/* empty css                        */

const _hoisted_1 = { class: "table-block__inner" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TableBlock",
  props: {
    hasLightVerticalHeader: { type: Boolean, default: false },
    cols: { default: 12 },
    colsCentered: { type: Boolean, default: true },
    contentCentered: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const { positioningClassNames } = useBlockPositioning(
      "table-block",
      props.cols,
      props.colsCentered,
      props.contentCentered
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["table-block", unref(positioningClassNames), { "has-light-vertical-table-header": props.hasLightVerticalHeader }])
      }, [
        createElementVNode("div", _hoisted_1, [
          createVNode(_sfc_main$1, {
            "has-light-vertical-header": props.hasLightVerticalHeader
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["has-light-vertical-header"])
        ])
      ], 2);
    };
  }
});

export { _sfc_main as default };
